/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import React from "react";
import HomepageTemplate from '../components/Homepage.js';
const MDXLayout = HomepageTemplate;
import './home.scss';
import {withPrefix} from "gatsby";
import {Row, Column} from 'gatsby-theme-carbon';
import WhatWeDoPanel from "../components/home/whatWeDoPanel";
import WhatsNewPanel from "../components/home/whatsNewPanel";
import NeedHelpPanel from "../components/home/needHelpPanel";
function _createMdxContent(props) {
  return React.createElement("div", {
    className: "homepage"
  }, React.createElement(WhatWeDoPanel), React.createElement(WhatsNewPanel), React.createElement(NeedHelpPanel));
}
function MDXContent(props = {}) {
  return React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props));
}
export default MDXContent;
